import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container text-center mt-5" }, [
  /*#__PURE__*/_createVNode("h1", null, "Getting started")
], -1)
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "lead" }, "What best describes your role?", -1)
const _hoisted_4 = { class: "row mt-lg-5" }
const _hoisted_5 = { class: "col-sm-12 col-lg mt-3" }
const _hoisted_6 = { class: "widget has-content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("header", { class: "widget-header" }, [
  /*#__PURE__*/_createVNode("span", { class: "header-text" }, "Developer")
], -1)
const _hoisted_8 = { class: "widget-body" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-12 col-lg mt-3\"><div class=\"widget has-content\"><header class=\"widget-header\"><span class=\"header-text\">Designer</span></header><main class=\"widget-body\"><a href=\"https://zeroheight.com/60d194782\" class=\"btn btn-link\">See styleguide →</a></main></div></div>", 1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-lg-3\"><div class=\"col-sm-12 col-lg mt-3\"><div class=\"widget has-content\"><header class=\"widget-header\"><span class=\"header-text\">Marketing</span></header><main class=\"widget-body\"><a href=\"https://zeroheight.com/60d194782\" class=\"btn btn-link\">See styleguide →</a></main></div></div><div class=\"col-sm-12 col-lg mt-3\"><div class=\"widget has-content\"><header class=\"widget-header\"><span class=\"header-text\">Unicorn 🦄</span></header><main class=\"widget-body\"><p>Well aren&#39;t you awesome?!</p></main></div></div></div><p class=\"mt-4\">We will add more resources for different roles soon!</p>", 2)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("main", _hoisted_8, [
              _createVNode("button", {
                class: "btn btn-link",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push('components')))
              }, " See UI components → ")
            ])
          ])
        ]),
        _hoisted_9
      ]),
      _hoisted_10
    ])
  ], 64 /* STABLE_FRAGMENT */))
}